import { Component } from "react";
import { reportError } from "@/lib/errorReporter";

/**
 * Top-level error boundary. Catches render-time errors anywhere below it and
 * shows a styled fallback instead of an unmounted (blank) page.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Uncaught error:", error, info);
    // A blank page is the hardest failure to describe over the phone — make
    // sure it reaches the Logs tab.
    reportError(error?.message || "React render error", {
      source: "ErrorBoundary",
      stack: `${error?.stack || ""}\n${info?.componentStack || ""}`.slice(0, 4000),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6 text-center grain-overlay">
          <div className="max-w-md">
            <h1 className="font-anton uppercase text-5xl md:text-6xl mb-4">
              <span className="text-[#B91C1C]">Off</span> Air
            </h1>
            <p className="text-white/70 font-manrope mb-8">
              Something went wrong on our end. Give it another shot.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="font-oswald uppercase tracking-[0.2em] text-sm bg-[#B91C1C] hover:bg-[#991B1B] text-white px-8 py-4 brutal-shadow"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
